import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';

const AppContainer = () => import('./Dashboard.vue');
const Suspended = () => import('./suspended/Index.vue');
const EmbeddedConversationView = () => import('./conversation/EmbeddedConversationView');

export default {
  routes: [
    ...helpcenterRoutes.routes,
    {
      path: frontendURL('embedded/accounts/:accountId/conversations/:conversationId'),
      name: 'embedded_conversation',
      roles: ['administrator', 'agent'],
      component: EmbeddedConversationView,
      props: route => ({
        inboxId: route.query.inboxId || 0,
        conversationId: route.params.conversationId,
      }),
    },
    {
      path: frontendURL('accounts/:account_id'),
      component: AppContainer,
      children: [
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...searchRoutes,
        ...notificationRoutes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      roles: ['administrator', 'agent'],
      component: Suspended,
    },
  ],
};
